// extracted by mini-css-extract-plugin
export default {"icon":"Info_icon__Szc5l","tooltip":"Info_tooltip__wvlLX","dialog":"Info_dialog__ncxb9"};